/* unplugin-vue-components disabled */import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import formatAmount from '@/shared/formatAmount';
import TrackingData from '@/shared/reportDataTracking';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'credit-first-retain-popup',
    props: {
        value: Boolean,
        step: Number
    },
    emits: [
        'close',
        'show-second'
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var userStore = useUserStore();
        var enterTime = ref(new Date());
        watch(function() {
            return props.value;
        }, function(val) {
            if (val) {
                TrackingData.trackPopup(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup-auth_detain',
                    taskHandler: 'popup-show'
                }));
            } else {
                if (isClickContinueBtn.value) {
                    isClickContinueBtn.value = false;
                    return;
                }
                TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                    popKindName: 'popup-auth_detain',
                    taskHandler: isClickCloseBtn.value ? 'popup-close' : 'popup-quit',
                    eventIntervalSpan: new Date() - enterTime.value
                }));
                if (isClickCloseBtn.value) {
                    isClickCloseBtn.value = false;
                }
            }
        });
        var isClickContinueBtn = ref(false);
        var clickContinueBtn = function() {
            isClickContinueBtn.value = true;
            emit('close');
            TrackingData.trackClick(_object_spread_props(_object_spread({}, userStore.commonData), {
                popKindName: 'popup-auth_detain',
                taskHandler: 'popup-continue'
            }));
        };
        var list = computed(function() {
            return [
                {
                    title: '¿Pensarlo otra vez?',
                    description: [
                        '¡Continúa completando tu solicitud! Una línea de crédito de hasta',
                        'está esperándote.'
                    ],
                    money: 3000000,
                    stepImg: require('@/assets/img/retain/step1.png')
                },
                {
                    title: '¡No te vayas tan rápido!',
                    description: 'Ha completado el 70%: acceso al crédito está cerca',
                    stepImg: require('@/assets/img/retain/step2.png')
                },
                {
                    title: '¡Espera! El éxito está cerca',
                    description: 'Continúa operando y podrás obtener un cupón de descuento de $100 en intereses.',
                    stepImg: require('@/assets/img/retain/step3.png')
                },
                {
                    title: '¡Falta poco! Desbloquea recompensas',
                    description: '¿Seguro que quieres salir? ¡Su límite de crédito se acreditará pronto!',
                    stepImg: require('@/assets/img/retain/step4.png')
                }
            ];
        });
        var currentObj = computed(function() {
            return list.value[props.step - 1];
        });
        var isClickCloseBtn = ref(false);
        var clickCloseBtn = function() {
            isClickCloseBtn.value = true;
            emit('close');
        };
        return {
            __sfc: true,
            userStore: userStore,
            props: props,
            emit: emit,
            enterTime: enterTime,
            isClickContinueBtn: isClickContinueBtn,
            clickContinueBtn: clickContinueBtn,
            list: list,
            currentObj: currentObj,
            isClickCloseBtn: isClickCloseBtn,
            clickCloseBtn: clickCloseBtn,
            formatAmount: formatAmount
        };
    }
};
